"use client";

import React from "react";
import AboutProducts from "../../assets/About_products.webp";
import AboutTrainings from "../../assets/About_trainings.webp";
import AboutConsulting from "../../assets/About_consulting.webp";
import AboutProjects from "../../assets/About_projects.webp";
import AboutServices from "../../assets/About_services.webp";

const businessData1 = [
  {
    title: "Products",
    description:
      "We offer education tech solutions including resume builders, skill-building courses, and career tools to support professional growth and success.",
    src: AboutProducts,
  },
  {
    title: "Trainings",
    description:
      "We provide specialized trainings in academic subjects, employability skills, and corporate development, tailored to enhance knowledge and career readiness.",
    src: AboutTrainings,
  },
  {
    title: "Consulting",
    description:
      "We offer expert consulting services in leadership development, maturity models, metrics management, and more, designed to drive organizational growth and efficiency.",
    src: AboutConsulting,
  },
  {
    title: "Projects",
    description:
      "We execute projects across sectors like government, information technology, and business process outsourcing, delivering tailored solutions for complex challenges.",
    src: AboutProjects,
  },
  {
    title: "Services",
    description:
      "We provide resource augmentation, hire-train-deploy solutions, and recruitment services to fulfill diverse talent needs.",
    src: AboutServices,
  },
];

const Business = () => {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <h2 className="text-4xl font-pt-sans font-bold mb-20">Our Businesses</h2>

      <div className="flex flex-wrap justify-center gap-12 max-w-7xl">
        {businessData1.map((business, index) => (
          <div
            key={index}
            className="flex w-[350px] flex-col items-center text-center box-border p-3 border border-gray-200 rounded-lg shadow-md"
          >
            <img
              className="w-full rounded-lg"
              src={business.src}
              alt={business.title}
            />
            <h3 className="text-xl font-pt-sans font-bold px-8 pt-4 pb-2">
              {business.title}
            </h3>
            <p className="text-gray-500 leading-5 text-sm font-normal font-pt-sans mt-2 px-8 pb-4">
              {business.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Business;
